<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-col cols="12" sm="8" xs="12">
      <v-app class="switch-app">
      </v-app>
    </v-col>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <date-picker :model="start_date"
                     label="start date"
                     @update="updateStartDate">
        </date-picker> &nbsp;
        <date-picker :model="end_date"
                     label="end date"
                     @update="updateEndDate"></date-picker>
        <div style="margin-top: -10px ; padding-left: 20px">
          <submit-button label="Export Excel" @click.native="exportExcel"/>
        </div>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in dataTable" :key="item.id">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{item.email}}</td>
            <td>
              <div v-for="data in item.interested_in">
                -{{data}}
              </div>
            </td>
            <td>{{item.updated_at | moment('DD-MM-YYYY')}}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate v-if="dataPaginate"
        :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import InputSearch from "../../../components/Input/InputSearch";
  import CircleButton from "../../../components/Button/CircleButton";
  import IconPencil from "../../../components/Icon/icon-pencil";
  import Paginate from "../../../components/Layout/Paginate";
  import {role} from "../../../util/Permission";
  import {mapState} from "vuex";
  import moment from "moment";
  import {domain} from "../../../util/Constants";
  import SubmitButton from "../../../components/Button/SubmitButton";
  import DatePicker from "../../../components/Input/DatePicker";
  import Swal from "sweetalert";
  import Loading from 'vue-loading-overlay';

  export default {
    name: "SubScribeTable",
    components: {DatePicker, SubmitButton, Paginate,
      IconPencil, CircleButton, InputSearch, Loading},
    computed: {
    },
    data() {
      return {
        title: "Subscribe",
        isLoading: false,
        headers: [
          { id: 1, text: "No." ,icon : null},
          { id: 2, text: "Email" ,icon : null},
          { id: 3, text: "interested in" ,icon : null},
          { id: 4, text: "Update date" ,icon : true},
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        permission : null,
        start_date : '',
        end_date : '',
        sort : 'desc'
      };
    },
    created() {
      this.permission = role;
      this.getSubScribeTable(1);
    },
    methods:{
      getSubScribeTable(page){
        this.isLoading = true;
        this.$store.dispatch("SupportContact/getSubScribe",{
          page,
          start_date : this.start_date ? moment(this.start_date).format("YYYY-MM-DD") : '',
          end_date : this.end_date ? moment(this.end_date).format("YYYY-MM-DD") : '',
          sort : this.sort,
        }).then(res=>{
          if(res.response_code == 200){
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          } else {
            this.dataTable = []
            this.dataPaginate = {
              current_page: 1,
              from: 1,
              last_page: 1,
              per_page: 1,
              total: 1,
              to: 1
            }
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get subscribe data','error');
          this.isLoading = false;
        });
      },
      exportExcel(){
        if (!this.start_date || !this.end_date) {
          Swal('','กรุณาเลือกวันที่ให้ครบ','error');
        } else {
          if (this.dataTable.length === 0) {
            Swal('','ไม่พบรายการข้อมูล','error');
            return
          }
          let start_date = this.start_date ? moment(this.start_date).format("YYYY-MM-DD") : '';
          let end_date = this.start_date ? moment(this.end_date).format("YYYY-MM-DD") : '';
          window.open(`${domain}/excel/excel_subscribe?start_date=${start_date}&end_date=${end_date}`)
        }
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getSubScribeTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      searchInput(val){
        this.search = val;
      },
      updateStartDate(val){
        this.start_date = val;
        this.getSubScribeTable(1);
      },
      updateEndDate(val){
        this.end_date = val;
        this.getSubScribeTable(1);
      },
      sortDataTable(){
        this.sort = this.sort == 'desc' ? 'asc' : 'desc';
        console.log(this.sort);
        this.getSubScribeTable(1);
      }
    }
  }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
